import React from "react";
import { motion } from "framer-motion";

const CaseStudyBanner = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.2 },
        },
    };

    const fadeUpVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
    };

    return (
        <section className="w-full bg-[#030914] py-16 sm:py-20 lg:py-28 px-5 sm:px-10 lg:px-[80px] text-left relative z-10 font-sans overflow-hidden">
            <div className="absolute inset-0 w-full h-full pointer-events-none mix-blend-screen opacity-70">
                <img
                    src="/assets/insights/bg5.png"
                    alt="Abstract blue wave background"
                    className="w-full h-full object-cover scale-105"
                />
            </div>

            <div className="max-w-[1440px] mx-auto w-full relative z-20">
                <div className="flex flex-col lg:flex-row items-center justify-between gap-10 lg:gap-16 w-full">

                    <motion.div
                        variants={containerVariants}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, margin: "-100px" }}
                        className="w-full lg:w-6/12 flex flex-col min-w-0"
                    >
                        <motion.h2
                            variants={fadeUpVariants}
                            className="text-[20px] md:text-[30px] max-w-[404px] font-[600] font-sora text-white mb-4 sm:mb-5 leading-[1.2] tracking-tight break-words"
                        >
                            Lending Consultation Outcomes and Roadmap
                        </motion.h2>
                        <motion.p
                            variants={fadeUpVariants}
                            className="text-[14px] sm:text-[16px] text-[#FFFFFF] font-graphik leading-relaxed font-[500] break-words max-w-[535px]"
                        >
                            Learn how we conducted a structured consultation to define a future-state lending roadmap for a regional US bank
                        </motion.p>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, scale: 0.97, y: 20 }}
                        whileInView={{ opacity: 1, scale: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
                        className="w-full lg:w-full max-w-[650px] bg-white p-6 sm:p-10 md:p-12 flex flex-col justify-center items-start shadow-xl shrink-0"
                    >
                        <h3 className="text-[16px] md:text-[20px] font-[600] font-sora text-[#01386A] mb-6 sm:mb-8 leading-[1.3] tracking-tight w-full break-words">
                            Download the full case study to review key findings, recommendations, and outcomes post-implementation.
                        </h3>

                        <a
                            href="#download"
                            className="inline-flex items-center gap-2 text-[14px] sm:text-[16px] font-[600] font-graphik text-[#0F3661] border-b-2 border-[#0F3661] pb-1 hover:text-[#ED6800] hover:border-[#ED6800] transition-colors duration-300 group outline-none select-none shrink-0"
                        >
                            <span>Download Now</span>
                            <span className="transition-transform duration-300 group-hover:translate-x-1.5 text-[16px]">&gt;</span>
                        </a>
                    </motion.div>

                </div>
            </div>
        </section>
    );
};

export default CaseStudyBanner;